import { render, staticRenderFns } from "./projectAdvantage.vue?vue&type=template&id=5c8586cb&scoped=true"
import script from "./projectAdvantage.vue?vue&type=script&lang=js"
export * from "./projectAdvantage.vue?vue&type=script&lang=js"
import style0 from "./projectAdvantage.vue?vue&type=style&index=0&id=5c8586cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8586cb",
  null
  
)

export default component.exports